import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const DocumentContext = createContext(null);

export const DocumentProvider = ({ children }) => {
  const [documents, setDocuments] = useState([]);
  const [processingDocuments, setProcessingDocuments] = useState({});
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

  useEffect(() => {
    console.log('Initial documents fetch');
    fetchDocuments();
  }, []);

  const fetchDocuments = useCallback(async () => {
    console.log('Fetching documents...');
    try {
      const response = await axios.get(`${API_URL}/documents/list`, {
        params: { _t: new Date().getTime() },
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });
      console.log('API Documents Response:', response.data);
      const processingDocs = response.data.filter(doc => 
        doc.embedding_status === 'processing' || 
        doc.processing_progress < 100
      );
      if (processingDocs.length > 0) {
        console.log('Documents still processing:', processingDocs);
      }
      setDocuments(response.data || []);
    } catch (error) {
      console.error('Error fetching documents:', error);
    }
  }, [API_URL]);

  const updateDocument = useCallback((docId, updates) => {
    setDocuments(prev => prev.map(doc => 
      doc.id === docId ? { ...doc, ...updates } : doc
    ));
  }, []);

  useEffect(() => {
    Object.entries(processingDocuments).forEach(([id, procDoc]) => {
      updateDocument(id, {
        embedding_status: procDoc.status,
        processing_progress: procDoc.progress
      });
    });
  }, [processingDocuments, updateDocument]);

  return (
    <DocumentContext.Provider value={{ 
      documents, 
      setDocuments, 
      fetchDocuments,
      processingDocuments,
      setProcessingDocuments,
      updateDocument
    }}>
      {children}
    </DocumentContext.Provider>
  );
};

export const useDocuments = () => useContext(DocumentContext); 